import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Text } from '../styles/components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 3px solid ${props => props.theme.colors.backgroundAlt};
  border-top: 3px solid ${props => props.theme.colors.brand};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: ${props => props.theme.spacing.lg};
`;

const ProcessingText = styled(Text)`
  color: ${props => props.theme.colors.text};
  font-size: ${props => props.theme.typography.sizes.bodyLarge};
  text-align: center;
`;

const SubText = styled(Text)`
  color: ${props => props.theme.colors.textLight};
  font-size: ${props => props.theme.typography.sizes.body};
  text-align: center;
  max-width: 400px;
  margin-top: ${props => props.theme.spacing.md};
`;

const ProcessingOverlay = () => (
  <Overlay>
    <Spinner />
    <ProcessingText>Analyzing your application</ProcessingText>
    <SubText>
      We're carefully reviewing your responses to ensure we can provide 
      the best possible beta experience for your needs.
    </SubText>
  </Overlay>
);

export default ProcessingOverlay; 